// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FreeTextQuestionGroup[data-v-466b3c52]{border-left:.714286rem solid;background-color:#f7f7f7;-webkit-box-shadow:0 3px 6px rgba(0,0,0,.16);box-shadow:0 3px 6px rgba(0,0,0,.16);margin-bottom:2.5rem;padding:1rem}.FreeTextQuestionGroup .title[data-v-466b3c52]{font-size:1.285714rem;font-weight:500;padding-bottom:1.071429rem;border-bottom:1px dashed #4b4b4b}.FreeTextQuestionGroup ul[data-v-466b3c52]{padding:0;list-style:none}", ""]);
// Exports
module.exports = exports;
